import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deleteCategory: [],
  loading: false,
  error: null,
};

const deleteCategorySlice = createSlice({
  name: "deleteCategory",
  initialState,
  reducers: {
    fetchDeleteCategorySuccess: (state, action) => {
      state.loading = false;
      state.deleteCategory = action.payload;
    },

    fetchDeleteCategoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchDeleteCategorySuccess, fetchDeleteCategoryFailure } =
  deleteCategorySlice.actions;

export default deleteCategorySlice.reducer;
